<template>
  <el-dialog
    v-if="notification"
    id="notificationModal"
    :title="$t('notification.notification')"
    :visible.sync="showLocal"
    :width="dialogWidth"
  >
    <div class="content">
      {{ notification.description }}
    </div>

    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="showLocal = false"
      >
        {{ $t('common.close') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialog from '@/mixins/dialog';

export default {
  mixins: [dialog],

  props: {
    notification: {
      type: Object,
      default: null,
    },
  },

  computed: {
    showLocal: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit('update:show', newValue);

        if (!newValue) {
          this.$emit('update:notification', null);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#notificationModal {
  text-align: left;
}
</style>
